import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';

//_Partials
import Header from "../../_partials/Header/Header";
import Sidebar from "../../_partials/Sidebar/Sidebar";

// Styles
import "./Dashboard.css";

class Dashboard extends Component {

    redirectUser = (path) => {
        this.props.history.push(path);
    }
    
    render() {
        return (
        <div className="AdminDashboard">
            <Header />
            <Container fluid>
                <Row>
                
                <Sidebar />
                <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
                    <h2>Dashboard</h2>
                    </main>
                </Row>
            </Container>
        </div>
        );
    }
}
export default Dashboard;
